// Action creators
// Constants
import { ClientFlavor, ClientType, LearnMoreLinks } from "@ms/uno-constants/lib/local/AppConstants";
import { multiPageDialogHostId } from "@ms/uno-constants/lib/local/DialogConstants";
import { NewsBarNewsIds } from "@ms/uno-constants/lib/local/NewsBarConstants";
import { SubRouteKeys, SubRouteType, ViewType } from "@ms/uno-constants/lib/local/RoutingConstants";
import { UserActivitySamplingResolutionMs } from "@ms/uno-constants/lib/local/UIBehaviorConstants";
import { ElementIds } from "@ms/uno-constants/lib/local/UIConstants";
import { TraceLevel } from "@ms/uno-telemetry/lib/local/events/Trace.event";
import { HeaderPlaceHolder } from "@ms/uno-controls/lib/local/controls/presentational/uxPlaceHolders/HeaderPlaceHolder";
import { CommandBarPlaceHolder } from "@ms/uno-controls/lib/local/controls/presentational/uxPlaceHolders/CommandBarPlaceHolder";
import { TaskBoardViewPlaceHolder } from "@ms/uno-controls/lib/local/controls/presentational/uxPlaceHolders/TaskBoardViewPlaceHolder";
import { BasicPlanTaskCardPlaceHolders, MyDayBannerMargin, MyDayBannerMinHeight, MyDayMyTaskTaskCardPlaceHolders, UnoFilterPivotHeight } from "@ms/uno-controls/lib/local/constants/StyleConstants";
import { ViewName } from "@ms/uno-constants/lib/local/ViewConstants";
// Controls
import { DirectionalHint, Spinner, SpinnerSize, createTheme } from "@fluentui/react";
import { SmartComponent } from "@ms/uno-controls/lib/local/controls/SmartComponent";
import { LazyAddNonMemberWarningDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyAddNonMemberWarningDialogContainer";
import { LazyAppInfoModal } from "@ms/uno-controls/lib/local/controls/container/LazyAppInfoModal";
import { LazyAuthErrorModalContainer } from "@ms/uno-controls/lib/local/controls/container/LazyAuthErrorModalContainer";
import { LazyCampaignCalloutContainer } from "@ms/uno-controls/lib/local/controls/container/LazyCampaignCalloutContainer";
import { LazyConvertPlanContainer } from "@ms/uno-controls/lib/local/controls/container/LazyConvertPlanContainer";
import { LazyCopilotUpsellContainer } from "@ms/uno-controls/lib/local/controls/container/LazyCopilotUpsellContainer";
import { LazyCopyAndMoveTaskDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyCopyAndMoveTaskDialogContainer";
import { LazyCopyPlanModalContainer } from "@ms/uno-controls/lib/local/controls/container/LazyCopyPlanModalContainer";
import { LazyDayTasksCopilotSidecarContainer } from "@ms/uno-controls/lib/local/controls/container/LazyDayTasksCopilotSidecarContainer";
import { LazyDeleteGroupDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyDeleteGroupDialogContainer";
import { LazyDeletePlanDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyDeletePlanDialogContainer";
import { LazyDeletePortfolioModalContainer } from "@ms/uno-controls/lib/local/controls/container/LazyDeletePortfolioModalContainer";
import { LazyDeleteRecurringTaskDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyDeleteRecurringTaskDialogContainer";
import { LazyDevPanelContainer } from "@ms/uno-controls/lib/local/controls/container/LazyDevPanelContainer";
import { LazyFormsIFrameDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyFormsIFrameDialogContainer";
import { LazyICalendarDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyICalendarDialogContainer";
import { LazyInfoModal } from "@ms/uno-controls/lib/local/controls/container/LazyInfoModal";
import { LazyLeavePlanDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyLeavePlanDialogContainer";
import { LazyNotificationBarContainer } from "@ms/uno-controls/lib/local/controls/container/LazyNotificationBarContainer";
import { LazyNotificationSettingsDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyNotificationSettingsDialogContainer";
import { LazyFloatingActionButtonContainer } from "@ms/uno-controls/lib/local/controls/container/LazyFloatingActionButtonContainer";
import { LazyRenamePlanDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyRenamePlanDialogContainer";
import { LazyRenamePortfolioDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyRenamePortfolioDialogContainer";
import { LazyRequestPremiumLicenseContainer } from "@ms/uno-controls/lib/local/controls/container/LazyRequestPremiumLicenseContainer";
import { LazyShareFileWarningDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazyShareFileWarningDialogContainer";
import { LazySharePlanDialogContainer } from "@ms/uno-controls/lib/local/controls/container/LazySharePlanDialogContainer";
import { LazySuiteNavContainer } from "@ms/uno-controls/lib/local/controls/container/LazySuiteNavContainer";
import { LazyTaskAttachmentDetailsEditorContainer } from "@ms/uno-controls/lib/local/controls/container/LazyTaskAttachmentDetailsEditorContainer";
import { LazyTaskEditorContainer } from "@ms/uno-controls/lib/local/controls/container/LazyTaskEditorContainer";
import { LazyTeamsSelectPlanModalContainer } from "@ms/uno-controls/lib/local/controls/container/LazyTeamsSelectPlanModalContainer";
import { LazyTeamsTabLandingExperienceContainer } from "@ms/uno-controls/lib/local/controls/container/LazyTeamsTabLandingExperienceContainer";
import { LazyToastContainer } from "@ms/uno-controls/lib/local/controls/container/LazyToastContainer";
import { LazyTryPremiumContainer } from "@ms/uno-controls/lib/local/controls/container/LazyTryPremiumContainer";
import { LazyUpsellStatusContainer } from "@ms/uno-controls/lib/local/controls/container/LazyUpsellStatusContainer";
import { LazyNewsBarContainer } from "@ms/uno-controls/lib/local/controls/container/newsBar/LazyNewsBarContainer";
import { LazyCreateTeamsTabPage } from "@ms/uno-controls/lib/local/controls/container/views/createTeamsTab/CreateTeamsTabPageLazyLoader";
import { LazyRemoveTeamsTabPage } from "@ms/uno-controls/lib/local/controls/container/views/removeTeamsTab/RemoveTeamsTabPageLazyLoader";
import { LazyFREDialog } from "@ms/uno-controls/lib/local/controls/presentational/freDialog/LazyFREDialog";
import { LazyGetSubscriptionCallout } from "@ms/uno-controls/lib/local/controls/presentational/getSubscriptionCallout/LazyGetSubscriptionCallout";
import { SuiteNavLoadingPlaceHolder } from "@ms/uno-controls/lib/local/controls/presentational/suiteNav/SuiteNavLoadingPlaceHolder";
import { CopyMoveCustomizerMode } from "@ms/uno-controls/lib/local/controls/presentational/taskCopyAndMoveCustomizer/TaskCopyAndMoveCustomizer.props";
import { LazyCreatePortfolioModalContainer } from "@ms/uno-createplan/lib/local/controls/container/LazyCreatePortfolioModalContainer";
import { LazyTeamsTabCreatePlanModalContainer } from "@ms/uno-createplan/lib/local/controls/container/LazyTeamsTabCreatePlanModalContainer";
import { LazyUnoCreatePlanModalContainer } from "@ms/uno-createplan/lib/local/controls/container/LazyUnoCreatePlanModalContainer";
import { LoopResponseSectionContainer } from "@ms/uno-loop/lib/local/controls/smart/loopResponseSection/LoopResponseSectionContainer";
import { LazyBasicPlanPage } from "@ms/uno-view-basicplan/lib/local/controls/container/basicPlanPage/BasicPlanPageLazyLoader";
import { LazyMyDayPage } from "@ms/uno-view-hub/lib/local/controls/container/myDayPage/MyDayPageLazyLoader";
import { LazyMyPlansPage } from "@ms/uno-view-hub/lib/local/controls/container/myPlansPage/MyPlansPageLazyLoader";
import { LazyMyPortfoliosPage } from "@ms/uno-view-hub/lib/local/controls/container/myPortfoliosPage/MyPortfoliosPageLazyLoader";
import { LazyMyTasksPage } from "@ms/uno-view-hub/lib/local/controls/container/myTasksPage/MyTasksPageLazyLoader";
import { LazyUnoLeftNavContainer } from "@ms/uno-view-leftnav/lib/local/controls/container/UnoLeftNavLazyLoader";
// Models
import { AssetLoadingError } from "@ms/uno-errors/lib/local/errors/AssetLoadingError";
import { TaskAccessContext } from "@ms/uno-models/lib/local/client/legacyPlanner/task/TaskAccessContext";
import { ModalType } from "@ms/uno-models/lib/local/client/modal/ModalType";
import { UnoChildView, UnoViewStatus } from "@ms/uno-models/lib/local/constants/UnoViewConstants";
import { UnoTheme } from "@ms/uno-models/lib/local/theme/UnoTheme";
import { extractMyDayRoutingDetailsFromSubRoute, extractMyTasksRoutingDetailsFromSubRoute } from "@ms/uno-routing";
// Styles
import { ThemeProvider } from "@fluentui/react";
import { appSpinnerStyles } from "@ms/uno-controls/lib/local/utilities/Mixin.styles";
import { getUnoShellClassNames, getUnoShellStyles } from "./UnoShell.styles";
// Telemetry
import { generateLogStringFromError, setCurrentRouteInfoForLogs } from "@ms/uno-telemetry/lib/local/utilities/LogUtilities";
// Utilities
import { ErrorUtilities } from "@ms/uno-errors/lib/local/utilities/ErrorUtilities";
import { Strings as LocaleStrings, loadTranslations } from "@ms/uno-resources/lib/local/CultureUtilities";
import { extractPlanRoutingDetailsFromSubRoute, getValueForKey } from "@ms/uno-routing";
import { safelyOpenExternalUrl } from "@ms/uno-utilities/lib/local/BrowserUtilities";
import { withDndContext } from "@ms/uno-utilities/lib/local/DndUtilities";
import { getUnoMainContentId } from "@ms/uno-utilities/lib/local/IdUtilities";
import { initializeAndRegisterIcons } from "@ms/uno-utilities/lib/local/ReactUtilities";
import map from "lodash/map";
import throttle from "lodash/throttle";
import moment from "moment";
import { default as React, Suspense } from "react";
import { Strings } from "../../utilities/CultureUtilities";
import { getThemeV8 } from "../../utilities/ThemeUtilities";
// Views
import { basicPlanInstantiateLoader } from "@ms/uno-view-basicplan/lib/local/controls/adapter/BasicPlanViewLazyLoader";
import { portfolioInstantiateLoader } from "@ms/uno-view-portfolio/lib/local/controls/adapter/portfolioViewLazyLoader";
import { LazyPremiumPlanView, premiumPlanInstantiateLoader } from "@ms/uno-view-premiumplan/lib/local/controls/adapter/PremiumPlanViewAdaptor/PremiumPlanLoaders";
import { LazyBasicPlanView } from "./BasicPlanLoader";
import { LazyLegacyTT, loadLegacyTTInstantiate } from "./LegacyTTLoader";
import { LazyPortfolioView } from "./PortfolioLoader";
// Workers
import { Worker } from "@ms/uno-workers/lib/local/workers/Worker";
// Contexts
import { ActionCreatorLoaderContext } from "@ms/uno-controls/lib/local/contexts/ActionCreatorLoaderContext";
import { ConfigProviderContext } from "@ms/uno-controls/lib/local/contexts/ConfigProviderContext";
import { LoggerContextProvider } from "@ms/uno-controls/lib/local/contexts/LoggerContext";
import { StoreLoaderContext } from "@ms/uno-controls/lib/local/contexts/StoreLoaderContext";
import { StoreSubscriptionManagerContext } from "@ms/uno-controls/lib/local/contexts/StoreSubscriptionManagerContext";
/**
 * UnoShell is the root component of the React tree
 */ class UnoShellInternal extends SmartComponent {
    async componentDidMount() {
        const { onLoad, onSuccess, actionCreatorProviders, configProvider, hostAdaptor, storeProviders, loggers } = this.props;
        if (hostAdaptor.canSetDocumentTitle()) {
            document.title = LocaleStrings.LandingPage_PlannerTitle;
        }
        loggers.traceLogger.logTrace(0x1e38669d /* tag_4og03 */ , TraceLevel.Info, "UnoShell component mounted. Notifying load.");
        onLoad();
        const clientFlavor = configProvider().sessionMetaData.appMetadata.clientFlavor;
        const unoShellStore = storeProviders.unoShell();
        const appContextStore = storeProviders.appContext();
        const theme = appContextStore.getAppContext().theme;
        const [modalStore, v8Theme, viewAc, newsBarStore] = await Promise.all([
            storeProviders.modal(),
            getThemeV8(theme, loggers.traceLogger),
            actionCreatorProviders.unoShellView(),
            storeProviders.newsBar()
        ]);
        this.setState({
            v8Theme: v8Theme,
            modalStore: modalStore,
            newsBarStore: newsBarStore
        });
        this.currentTheme = theme;
        const routeStore = storeProviders.route();
        this.addStoresToSubscribeTo([
            routeStore,
            modalStore,
            unoShellStore,
            appContextStore,
            newsBarStore
        ]);
        super.componentDidMount();
        loggers.traceLogger.logTrace(0x1e38669c /* tag_4og02 */ , TraceLevel.Info, "UnoShell mount complete. Notifying success.");
        onSuccess();
        this.runComponentDidMountSideEffects(viewAc, routeStore, clientFlavor);
        if (!configProvider().flights.EnableTaskEditorRouting) {
            // Open TaskEditor if the route contains a taskId
            // TODO: #8819262 - This should be handled at page level and not at shell level
            const subRouteType = routeStore.getCurrentSubRouteType();
            const taskId = getValueForKey(routeStore.getCurrentSubRoute(), SubRouteKeys.Task);
            if (subRouteType === SubRouteType.MyTasks && taskId) {
                const modalAC = await actionCreatorProviders.modal();
                // IMPORTANT: await'ing this call is necessary to ensure the task editor is opened quickly
                await modalAC.openTaskEditorModal(taskId, TaskAccessContext.AssignedToUser);
            }
        }
    }
    async componentDidUpdate(_prevProps, prevState) {
        const { storeProviders, loggers } = this.props;
        const routeStore = storeProviders.route();
        const subRouteType = routeStore.getCurrentSubRouteType();
        setCurrentRouteInfoForLogs(subRouteType, routeStore.getCurrentSubRoute(), loggers.logHandler);
        // Update theme
        const context = storeProviders.appContext().getAppContext();
        const theme = context.theme;
        if (this.currentTheme !== theme) {
            const v8Theme = await getThemeV8(theme, this.props.loggers.traceLogger);
            this.setState({
                v8Theme
            });
            this.currentTheme = theme;
        }
        await this.instantiateChildViewsIfNeeded();
    }
    /**
     * Name of this component. Used for usage logging.
     */ name() {
        return "UnoShell";
    }
    /**
     * Render the Uno shell
     */ renderComponent() {
        // If the theme or stores are not loaded yet, don't render anything
        if (!this.state.v8Theme || !this.state.modalStore) {
            return null;
        }
        const { storeProviders, configProvider } = this.props;
        const routeStore = storeProviders.route();
        const subRouteType = routeStore.getCurrentSubRouteType();
        const isTaskPublishingRoute = subRouteType === SubRouteType.Publishing;
        const clientFlavor = configProvider().sessionMetaData.appMetadata.clientFlavor;
        const unoShellClassNames = this.getUnoShellClassNames(this.state.v8Theme);
        return(// The ThemeProvider provides theming for Fluent v8 components
        /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: this.state.v8Theme
        }, /*#__PURE__*/ React.createElement("div", {
            className: unoShellClassNames.root,
            id: this.getUnoMainContentId()
        }, this.renderNewsBar(NewsBarNewsIds.OcdiRedirectExperience), // For task publishing route, give entire page to legacyTT view since, it has its own
        // leftNav and right main content view
        isTaskPublishingRoute ? this.renderLegacyTeamsTasksView() : /*#__PURE__*/ React.createElement(React.Fragment, null, this.renderSuiteNav(), this.renderAppContent(unoShellClassNames, clientFlavor, subRouteType), this.renderModalLayers(), this.renderFAB(), this.renderDevTools(), this.renderToastContainer(), this.renderCampaignCallout()))));
    }
    /**
     * Runs side effects after the component has mounted
     * @param viewAc The view action creator
     * @param routeStore The route store
     * @param clientFlavor The client flavor
     */ async runComponentDidMountSideEffects(viewAc, routeStore, clientFlavor) {
        const { isDevMode, loggers, configProvider } = this.props;
        const enablePortfolioExperience = configProvider().flights.EnablePortfolioExperience;
        const subRouteType = routeStore.getCurrentSubRouteType();
        viewAc.fetchViewData();
        setCurrentRouteInfoForLogs(subRouteType, routeStore.getCurrentSubRoute(), loggers.logHandler);
        await this.populateViewInstanceConfig();
        this.updateCurrentUserInStore();
        this.fetchUpsellDataAsync();
        this.lazyInstantiateLegacyTTIfNeeded().catch((e)=>{
        /* do nothing */ });
        this.startUserActivityTracking();
        this.instantiateBasicPlan(isDevMode ?? false).catch((e)=>{
        /* do nothing */ });
        // Instantiate premium plan only if required
        if (!configProvider().flights.EnableInstantiatePremiumPlanFromWorker) {
            if (clientFlavor === ClientFlavor.App || subRouteType === SubRouteType.PremiumPlan) {
                this.instantiatePremiumPlan(isDevMode ?? false).catch((e)=>{
                /* do nothing */ });
            }
        }
        // Instantiate portfolio only if required
        if (enablePortfolioExperience && (clientFlavor === ClientFlavor.App || subRouteType === SubRouteType.Portfolio)) {
            this.instantiatePortfolio(isDevMode ?? false).catch((e)=>{
            /* do nothing */ });
        }
        // Instantiate office feedback sdk
        this.setupOfficeFeedback(isDevMode ?? false).catch((e)=>{
        /* do nothing */ });
        this.startHistoryObserverWorker();
    }
    /**
     * Instantiates child views if needed
     */ async instantiateChildViewsIfNeeded() {
        const { configProvider } = this.props;
        // Must be awaited! This will be fixed later with the uno native impl of publishing views.
        await this.lazyInstantiateLegacyTTIfNeeded();
        if (!configProvider().flights.EnableNativeBasicPlanViews) {
            this.instantiateViewIfNeeded(UnoChildView.BasicPlan, SubRouteType.BasicPlan, this.instantiateBasicPlan.bind(this), this.props.isDevMode ?? false);
        }
        // Continue instantiate premium plan from shell when flight off
        if (!configProvider().flights.EnableInstantiatePremiumPlanFromWorker) {
            this.instantiateViewIfNeeded(UnoChildView.PremiumPlan, SubRouteType.PremiumPlan, this.instantiatePremiumPlan.bind(this), this.props.isDevMode ?? false);
        }
        this.instantiateViewIfNeeded(UnoChildView.Portfolio, SubRouteType.Portfolio, this.instantiatePortfolio.bind(this), this.props.isDevMode ?? false);
    }
    /**
     * Instantiates the view if needed
     * @param view The view to instantiate
     * @param associatedSubRouteType The sub route type associated with the view
     * @param instantiateFn The function to call to instantiate the view
     * @param isDevMode Whether the shell is in dev mode
     */ instantiateViewIfNeeded(view, associatedSubRouteType, instantiateFn, isDevMode) {
        const { storeProviders } = this.props;
        const unoShell = storeProviders.unoShell();
        const routeStore = storeProviders.route();
        const status = unoShell.getChildViewInstantiationStatus(view);
        const subRouteType = routeStore.getCurrentSubRouteType();
        // Reset the instantiation started flag if the view is already instantiated or errored
        if (status === UnoViewStatus.Instantiated || status === UnoViewStatus.Error) {
            this.instantiationStartedFlags[view] = false;
        }
        if (status === UnoViewStatus.ReInstantiate || subRouteType === associatedSubRouteType && status === UnoViewStatus.NotLoaded) {
            instantiateFn(isDevMode).catch(()=>{
            /* do nothing */ });
        }
    }
    /**
     * Starts the history observer worker
     */ startHistoryObserverWorker() {
        const { workerLoader, loggers } = this.props;
        try {
            workerLoader.load(Worker.HistoryObserver).init();
        } catch (e) {
            loggers.traceLogger.logTrace(0x1e281201 /* tag_4kbib */ , TraceLevel.Warning, `Failed to start history observer [ErrorType=${e.name}][Error=${e.message}]`);
        }
    }
    /**
     * Instantiates the premium plan view
     * @param isDevMode Indicates whether the shell is in dev mode
     */ async instantiatePremiumPlan(isDevMode) {
        const { loggers, storeProviders, actionCreatorProviders } = this.props;
        const unoShell = storeProviders.unoShell();
        const childView = UnoChildView.PremiumPlan;
        const status = unoShell.getChildViewInstantiationStatus(childView);
        // If premium plan is already instantiated or in the process of being instantiated, don't instantiate again
        if (this.instantiationStartedFlags[childView] || status === UnoViewStatus.Instantiated || status === UnoViewStatus.InstantiationStarted || status === UnoViewStatus.ScriptsLoaded || status === UnoViewStatus.Error) {
            return;
        }
        this.instantiationStartedFlags[childView] = true;
        const unoShellAc = await actionCreatorProviders.unoShell();
        // Load scripts
        let premiumPlanInstantiator;
        try {
            premiumPlanInstantiator = await premiumPlanInstantiateLoader();
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.ScriptsLoaded);
        } catch (e) {
            const err = new AssetLoadingError(e.name, e.message);
            loggers.traceLogger.logTrace(0x1e3ce04e /* tag_4pobo */ , TraceLevel.Warning, `[ErrorType=${err.name}][Error=${err.message}]`);
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Error);
            this.scheduleRetryInstantiation(childView);
            return;
        }
        // Instantiate premium plan
        try {
            if (isDevMode) {
                await premiumPlanInstantiator.premiumPlanDevViewInstantiator.instantiate(this.viewInstanceConfig);
            } else {
                await premiumPlanInstantiator.premiumPlanViewInstantiator.instantiate(this.viewInstanceConfig);
            }
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Instantiated);
            this.instantiationRetryCounts[childView] = 0;
        } catch (e) {
            // Temporary logging to solve why we're getting empty errors here
            loggers.traceLogger.logTrace(0x1e31e123 /* tag_4m4e9 */ , TraceLevel.Warning, `InitializationError - ${generateLogStringFromError(e)}`);
            // Don't throw error, show view's error state to user
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Error);
            this.scheduleRetryInstantiation(childView);
        }
    }
    /**
     * Instantiates the basic plan view
     * @param isDevMode Indicates whether the shell is in dev mode
     */ async instantiateBasicPlan(isDevMode) {
        const { loggers, actionCreatorProviders, storeProviders } = this.props;
        const unoShellAc = await actionCreatorProviders.unoShell();
        const childView = UnoChildView.BasicPlan;
        const unoShell = storeProviders.unoShell();
        const status = unoShell.getChildViewInstantiationStatus(UnoChildView.BasicPlan);
        // If basic plan instantiation has already started, don't instantiate again
        if (this.instantiationStartedFlags[childView] || status === UnoViewStatus.Instantiated || status === UnoViewStatus.InstantiationStarted || status === UnoViewStatus.ScriptsLoaded || status === UnoViewStatus.Error) {
            return;
        }
        this.instantiationStartedFlags[childView] = true;
        loggers.traceLogger.logTrace(0x1e28e460 /* tag_4kor6 */ , TraceLevel.Info, "Starting basic plan view instantiation");
        let basicPlanInstantiator;
        try {
            basicPlanInstantiator = await basicPlanInstantiateLoader();
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.ScriptsLoaded);
        } catch (e) {
            const err = new AssetLoadingError(e.name, e.message);
            loggers.traceLogger.logTrace(0x1e3ce04c /* tag_4pobm */ , TraceLevel.Warning, `[ErrorType=${err.name}][Error=${err.message}]`);
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Error);
            this.scheduleRetryInstantiation(childView);
            return;
        }
        // Instantiate basic plan
        try {
            if (isDevMode) {
                await basicPlanInstantiator.basicPlanDevViewInstantiator.instantiate(this.viewInstanceConfig);
            } else {
                await basicPlanInstantiator.basicPlanViewInstantiator.instantiate(this.viewInstanceConfig);
            }
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Instantiated);
            this.instantiationRetryCounts[childView] = 0;
        } catch (e) {
            loggers.traceLogger.logTrace(0x1e31e19c /* tag_4m4g2 */ , TraceLevel.Warning, `InitializationError - ${generateLogStringFromError(e)}`);
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Error);
            this.scheduleRetryInstantiation(childView);
        }
    }
    /**
     * Schedules a retry for the view that failed to instantiate
     * @param view The view that failed to instantiate
     */ async scheduleRetryInstantiation(view) {
        const { actionCreatorProviders, loggers, configProvider } = this.props;
        const unoShellAc = await actionCreatorProviders.unoShell();
        const retryCount = this.instantiationRetryCounts[view];
        const instantiationSettings = configProvider().settings.instantiation;
        if (retryCount < instantiationSettings.maxRetryCount) {
            this.instantiationRetryCounts[view]++;
            setTimeout(()=>{
                unoShellAc.updateChildViewInstantiationStatus(view, UnoViewStatus.ReInstantiate);
            }, instantiationSettings.retryIntervalMs);
            loggers.traceLogger.logTrace(0x1e28e45f /* tag_4kor5 */ , TraceLevel.Info, `InitializationError - ${view} view failed to instantiate. Retrying instantiation. [RetryCount=${retryCount}]`);
        } else {
            loggers.traceLogger.logTrace(0x1e28e45e /* tag_4kor4 */ , TraceLevel.Error, `InitializationError - ${view} view failed to instantiate and won't retry. [RetryCount=${retryCount}]`);
        }
    }
    /**
     * Instantiates the portfolio view
     * @param isDevMode Indicates whether the shell is in dev mode
     */ async instantiatePortfolio(isDevMode) {
        const { hostAdaptor, loggers, actionCreatorProviders, storeProviders } = this.props;
        const unoShell = storeProviders.unoShell();
        const childView = UnoChildView.Portfolio;
        const status = unoShell.getChildViewInstantiationStatus(childView);
        // If portfolio instantiation has already started, don't instantiate again
        if (this.instantiationStartedFlags[childView]) {
            return;
        }
        // If portfolio is already instantiated or in the process of being instantiated, don't instantiate again
        if (status === UnoViewStatus.Instantiated || status === UnoViewStatus.InstantiationStarted || status === UnoViewStatus.ScriptsLoaded || status === UnoViewStatus.Error) {
            return;
        }
        this.instantiationStartedFlags[childView] = true;
        const unoShellAc = await actionCreatorProviders.unoShell();
        let portfolioInstantiator;
        try {
            portfolioInstantiator = await portfolioInstantiateLoader();
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.ScriptsLoaded);
        } catch (e) {
            const err = new AssetLoadingError(e.name, e.message);
            loggers.traceLogger.logTrace(0x1e3cc544 /* tag_4pmve */ , TraceLevel.Warning, `[ErrorType=${err.name}][Error=${err.message}]`);
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Error);
            this.scheduleRetryInstantiation(childView);
            return;
        }
        // Instantiate portfolio
        try {
            const portfolioViewInstanceConfig = {
                ...this.viewInstanceConfig,
                hostAdaptor
            };
            if (isDevMode) {
                await portfolioInstantiator.portfolioDevViewInstantiator.instantiate(portfolioViewInstanceConfig);
            } else {
                await portfolioInstantiator.portfolioViewInstantiator.instantiate(portfolioViewInstanceConfig);
            }
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Instantiated);
            this.instantiationRetryCounts[childView] = 0;
        } catch (e) {
            // Temporary logging to solve why we're getting empty errors here
            loggers.traceLogger.logTrace(0x1e31c7c7 /* tag_4m25h */ , TraceLevel.Warning, `InitializationError - ${generateLogStringFromError(e)}`);
            // Don't throw error, show view's error state to user
            unoShellAc.updateChildViewInstantiationStatus(childView, UnoViewStatus.Error);
            this.scheduleRetryInstantiation(childView);
        }
    }
    async populateViewInstanceConfig() {
        const { dispatcherEventManagement, storeProviders, actionCreatorProviders, hostAdaptor, serviceProviders, logicModuleProviders, loggers, configProvider } = this.props;
        const appContext = storeProviders.appContext().getAppContext();
        this.viewInstanceConfig = {
            dispatcherEventManagement,
            context: appContext,
            actionCreatorProviders,
            hostAdaptor,
            serviceProviders,
            storeProviders,
            logicModuleProviders,
            loggers,
            configProvider
        };
    }
    /**
     * First determines whether legacyTT view needs instantiation.
     * If needed, proceeds lazy-loading the legacyTT instantiator and instantiates legacyTT,
     * while async updating the legacyTTStatus state and causing side-effects as it proceeds.
     * Idempotent, no-op if already proceeded with instantiation.
     */ async lazyInstantiateLegacyTTIfNeeded() {
        // Ensure we only trigger this lazy instantiation once, and not multiple times in
        // multiple subsequent render cycles. If status is anything other than initial NotLoaded,
        // we've already triggered instantiation once so no-op
        if (this.viewStatuses.legacyTTStatus !== UnoViewStatus.NotLoaded) {
            // no-op
            return;
        }
        const { hostAdaptor, loggers, storeProviders } = this.props;
        const subRouteType = storeProviders.route().getCurrentSubRouteType();
        // Determine whether to instantiate legacyTT based on whether user has navigated to a legacyTT view needing route (task publishing) when publishing is enabled
        const isNeededNowToRender = subRouteType === SubRouteType.Publishing;
        const isPublishingEnabled = (await storeProviders.capabilities()).getIsPublishingEnabled();
        // If none of the cases, no-op
        if (!(isNeededNowToRender && isPublishingEnabled)) {
            return;
        }
        // Needs to be instantiated, begin. No react state change.
        this.viewStatuses.legacyTTStatus = UnoViewStatus.InstantiationStarted;
        // Lazy-load legacyTT instantiator
        try {
            const legacyTTInst = (await loadLegacyTTInstantiate()).tasksInTeamInstantiator;
            // Lazy-loaded. No react state change.
            this.viewStatuses.legacyTTStatus = UnoViewStatus.ScriptsLoaded;
            await legacyTTInst.instantiate({
                ...this.viewInstanceConfig,
                hostAdaptor
            });
            // Instantiated.
            this.viewStatuses.legacyTTStatus = UnoViewStatus.Instantiated;
            // Trigger state change, so Shell re-renders and can now render LegacyTT view
            this.setState({
                legacyTTStatus: UnoViewStatus.Instantiated
            });
        } catch (e) {
            const err = new AssetLoadingError(e.name, e.message);
            loggers.traceLogger.logTrace(0x1e3dc1a1 /* tag_4p2g7 */ , TraceLevel.Error, `[ErrorType=${err.name}][Error=${err.message}]`);
            // Errored.
            this.viewStatuses.legacyTTStatus = UnoViewStatus.Error;
            // Trigger state change, so Shell re-renders and should now render Error state
            this.setState({
                legacyTTStatus: UnoViewStatus.Error
            });
            throw err;
        }
    }
    /**
     * Update current user in user store
     */ async updateCurrentUserInStore() {
        const appContext = this.props.storeProviders.appContext().getAppContext();
        const userId = appContext.userId;
        if (userId == null) {
            const msg = "This should never happen. UserId retrieved from app context is null";
            this.props.loggers.traceLogger.logTrace(0x1e488815 /* tag_4si6v */ , TraceLevel.Error, msg);
            throw new Error(msg);
        }
        (await this.props.actionCreatorProviders.user()).fetchUsers([
            userId
        ], true);
    }
    /**
     * Renders Uno leftNav
     */ renderLeftNav() {
        const { dispatcherEventManagement, actionCreatorProviders, storeProviders, loggers, configProvider } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLeftNavPlaceholder()
        }, /*#__PURE__*/ React.createElement(LazyUnoLeftNavContainer, {
            dispatcherEventManagement: dispatcherEventManagement,
            actionCreatorProviders: actionCreatorProviders,
            storeProviders: storeProviders,
            loggers: loggers,
            configProvider: configProvider
        }));
    }
    /**
     * Render Uno LeftNav Suspense fallback
     */ renderLeftNavPlaceholder() {
        if (!this.state.v8Theme) {
            return null;
        }
        const unoLeftNavClassNames = getUnoShellClassNames(getUnoShellStyles(this.state.v8Theme));
        return /*#__PURE__*/ React.createElement("div", {
            className: unoLeftNavClassNames.leftNavContainer
        }, this.renderLoadingSpinner());
    }
    /**
     * Renders the primary view of the Uno shell
     */ renderPrimaryView() {
        const { storeProviders, loggers, configProvider } = this.props;
        const routeStore = storeProviders.route();
        const subRouteType = routeStore.getCurrentSubRouteType();
        const enableNativeBasicPlanViews = configProvider().flights.EnableNativeBasicPlanViews;
        switch(subRouteType){
            case SubRouteType.NewTabPage:
                return this.renderNewTabLandingPage();
            case SubRouteType.MyDay:
                const planRoutingDetailsMyDay = extractMyDayRoutingDetailsFromSubRoute(routeStore.getCurrentSubRoute(), subRouteType);
                return this.renderMyDayPage(planRoutingDetailsMyDay.viewType);
            case SubRouteType.MyTasks:
                const planRoutingDetailsMyTasks = extractMyTasksRoutingDetailsFromSubRoute(routeStore.getCurrentSubRoute(), subRouteType);
                return this.renderMyTasksPage(planRoutingDetailsMyTasks.viewType);
            case SubRouteType.TodoList:
                const planId = extractPlanRoutingDetailsFromSubRoute(routeStore.getCurrentSubRoute(), subRouteType).planId;
                return this.renderBasicPlanPage(planId);
            case SubRouteType.MyPlans:
                return this.renderMyPlansPage();
            case SubRouteType.BasicPlan:
                if (enableNativeBasicPlanViews) {
                    const planRoutingDetails = extractPlanRoutingDetailsFromSubRoute(routeStore.getCurrentSubRoute(), subRouteType);
                    return this.renderBasicPlanPage(planRoutingDetails.planId, planRoutingDetails.viewType);
                }
                return this.renderBasicPlanView();
            case SubRouteType.PremiumPlan:
                return this.renderPremiumPlanView();
            case SubRouteType.Portfolio:
                return this.renderPortfolioView();
            case SubRouteType.MyPortfolios:
                return this.renderMyPortfoliosView();
            case SubRouteType.MessageTasks:
                return null;
            case SubRouteType.Publishing:
                return null;
            case SubRouteType.ConfigTeamsTab:
                return this.renderCreateTeamsTabPage();
            case SubRouteType.RemoveTeamsTab:
                return this.renderRemoveTeamsTabPage();
            default:
                ErrorUtilities.unreachableCase(subRouteType, (log)=>{
                    loggers.traceLogger.logTrace(0x1e488814 /* tag_4si6u */ , TraceLevel.Error, log);
                });
                return null;
        }
    }
    renderNewTabLandingPage() {
        const { actionCreatorProviders, storeProviders, hostAdaptor, dispatcherEventManagement, loggers } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyTeamsTabLandingExperienceContainer, {
            storeProviders: storeProviders,
            actionCreatorProviders: actionCreatorProviders,
            dispatchPageReady: this.dispatchPageReady,
            canSetDocumentTitle: hostAdaptor.canSetDocumentTitle(),
            dispatcherEventManagement: dispatcherEventManagement,
            loggers: loggers
        }));
    }
    renderLegacyTeamsTasksView() {
        // We care about three possible states here:
        // not Instantiated i.e. Loading,
        // Instantiated i.e. ready so render it, and
        // Error i.e. show some error UX instead of rendering view
        // TODO: WI#8826872: Deal with view error state
        return this.state.legacyTTStatus !== UnoViewStatus.Instantiated ? this.renderLoadingSpinner() : /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyLegacyTT, null));
    }
    renderMyDayPage(viewPivot = ViewType.Grid) {
        const { configProvider, actionCreatorProviders, hostAdaptor, dispatcherEventManagement, storeProviders, loggers } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderPageLoading(viewPivot, ViewName.MyDayPage)
        }, /*#__PURE__*/ React.createElement(LazyMyDayPage, {
            dispatcherEventManagement: dispatcherEventManagement,
            dispatchPageReady: this.dispatchPageReady,
            actionCreatorProviders: actionCreatorProviders,
            storeLoader: storeProviders,
            configProvider: configProvider,
            loggers: loggers,
            theme: this.getTheme(),
            canSetDocumentTitle: hostAdaptor.canSetDocumentTitle()
        }));
    }
    renderMyTasksPage(viewPivot = ViewType.Grid) {
        const { configProvider, actionCreatorProviders, dispatcherEventManagement, hostAdaptor, storeProviders, loggers } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderPageLoading(viewPivot, ViewName.MyTasksPage)
        }, /*#__PURE__*/ React.createElement(LazyMyTasksPage, {
            configProvider: configProvider,
            dispatcherEventManagement: dispatcherEventManagement,
            dispatchPageReady: this.dispatchPageReady,
            actionCreatorProviders: actionCreatorProviders,
            storeLoader: storeProviders,
            loggers: loggers,
            theme: this.getTheme(),
            canSetDocumentTitle: hostAdaptor.canSetDocumentTitle()
        }));
    }
    /**
     * Placeholder for rending the pages
     * @param viewPivot : ViewPivot are pages we are going too load
     * @param currView : Current view name from which it is called
     */ renderPageLoading(viewPivot, currView) {
        const isCurrentViewMyDayOrMyTasks = currView === ViewName.MyDayPage || currView === ViewName.MyTasksPage;
        let commandBarHeight = UnoFilterPivotHeight;
        if (currView === ViewName.MyDayPage) {
            commandBarHeight = MyDayBannerMinHeight + 2 * MyDayBannerMargin; // as for MyDay Banner it has both top and bottom margin.
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(HeaderPlaceHolder, null), /*#__PURE__*/ React.createElement(CommandBarPlaceHolder, {
            commandBarHeight: commandBarHeight
        }), viewPivot && viewPivot === ViewType.Board ? // Currently for the premium plan rendering from the uno shell is not present
        /*#__PURE__*/ React.createElement(TaskBoardViewPlaceHolder, {
            numberOfTaskCardsPerColumn: isCurrentViewMyDayOrMyTasks ? MyDayMyTaskTaskCardPlaceHolders : BasicPlanTaskCardPlaceHolders,
            showAddTaskButtonShimmer: !isCurrentViewMyDayOrMyTasks
        }) : this.renderLoadingSpinner());
    }
    renderBasicPlanPage(planId, viewPivot = ViewType.Grid) {
        const { actionCreatorProviders, dispatcherEventManagement, hostAdaptor, storeProviders, loggers, configProvider, agentProviders } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderPageLoading(viewPivot, ViewName.BasicPlanPage)
        }, /*#__PURE__*/ React.createElement(LazyBasicPlanPage, {
            dispatcherEventManagement: dispatcherEventManagement,
            dispatchPageReady: this.dispatchPageReady,
            actionCreatorProviders: actionCreatorProviders,
            storeLoader: storeProviders,
            configProvider: configProvider,
            agentProviders: agentProviders,
            loggers: loggers,
            planId: planId,
            theme: this.getTheme(),
            isTabView: configProvider().sessionMetaData.appMetadata.clientFlavor === ClientFlavor.Tab,
            currentPivot: viewPivot,
            canSetDocumentTitle: hostAdaptor.canSetDocumentTitle()
        }));
    }
    renderMyPlansPage() {
        const { actionCreatorProviders, dispatcherEventManagement, hostAdaptor, storeProviders, loggers, configProvider } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyMyPlansPage, {
            dispatcherEventManagement: dispatcherEventManagement,
            dispatchPageReady: this.dispatchPageReady,
            actionCreatorProviders: actionCreatorProviders,
            storeLoader: storeProviders,
            loggers: loggers,
            configProvider: configProvider,
            canSetDocumentTitle: hostAdaptor.canSetDocumentTitle()
        }));
    }
    /**
     * Renders the empty modal for spinner
     */ renderEmptyModal() {
        if (!this.state.v8Theme || !this.state.modalStore) {
            return null;
        }
        const unoShellClassNames = this.getUnoShellClassNames(this.state.v8Theme);
        return /*#__PURE__*/ React.createElement("div", {
            className: unoShellClassNames.emptyModal
        }, this.renderLoadingSpinner());
    }
    /**
     * Renders the basic plan view
     */ renderBasicPlanView() {
        // TODO 8826872: Deal with instantiation error state
        const unoShell = this.props.storeProviders.unoShell();
        const status = unoShell.getChildViewInstantiationStatus(UnoChildView.BasicPlan);
        return status === UnoViewStatus.Instantiated ? /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyBasicPlanView, null)) : this.renderLoadingSpinner();
    }
    /**
     * Renders the premium plan view
     */ renderPremiumPlanView() {
        // TODO 8826872: Deal with instantiation error state
        const unoShell = this.props.storeProviders.unoShell();
        const status = unoShell.getChildViewInstantiationStatus(UnoChildView.PremiumPlan);
        return status === UnoViewStatus.Instantiated ? /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyPremiumPlanView, null)) : this.renderLoadingSpinner();
    }
    /**
     * Renders the portfolio view
     */ renderPortfolioView() {
        const unoShell = this.props.storeProviders.unoShell();
        const status = unoShell.getChildViewInstantiationStatus(UnoChildView.Portfolio);
        return status === UnoViewStatus.Instantiated ? /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyPortfolioView, null)) : this.renderLoadingSpinner();
    }
    /**
     * Renders the my portfolios view
     */ renderMyPortfoliosView() {
        const { actionCreatorProviders, dispatcherEventManagement, hostAdaptor, storeProviders, loggers, configProvider } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyMyPortfoliosPage, {
            dispatcherEventManagement: dispatcherEventManagement,
            dispatchPageReady: this.dispatchPageReady,
            actionCreatorProviders: actionCreatorProviders,
            storeProviders: storeProviders,
            loggers: loggers,
            configProvider: configProvider,
            canSetDocumentTitle: hostAdaptor.canSetDocumentTitle()
        }));
    }
    /**
     * Renders the remove teams tab page
     */ renderRemoveTeamsTabPage() {
        const { actionCreatorProviders, storeProviders, dispatcherEventManagement, hostAdaptor, loggers, configProvider } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyRemoveTeamsTabPage, {
            dispatcherEventManagement: dispatcherEventManagement,
            actionCreatorProviders: actionCreatorProviders,
            storeProviders: storeProviders,
            teamsHostAdaptor: hostAdaptor,
            configProvider: configProvider,
            loggers: loggers
        }));
    }
    /**
     * Renders the modal layers of the Uno shell
     */ renderModalLayers() {
        const currentModalLayers = this.state.modalStore ? this.state.modalStore.getCurrentModalDataLayers() : [
            {
                modalType: ModalType.None
            }
        ];
        return /*#__PURE__*/ React.createElement(React.Fragment, null, map(currentModalLayers, (currentModal)=>{
            return /*#__PURE__*/ React.createElement(Suspense, {
                fallback: this.renderEmptyModal()
            }, this.renderModal(currentModal));
        }));
    }
    /**
     * Renders the loop response section for task editor
     */ renderLoopPage(taskId) {
        const { logicModuleProviders } = this.props;
        const authModule = logicModuleProviders.auth();
        const fetchAccessToken = async (resource, claims)=>{
            const tokenWithExpiry = await authModule.fetchAccessTokenAsync(resource, claims);
            return tokenWithExpiry.accessToken;
        };
        return /*#__PURE__*/ React.createElement(LoopResponseSectionContainer, {
            fetchAccessTokenCallback: fetchAccessToken,
            taskId: taskId
        });
    }
    /**
     * Renders the modal of the Uno shell
     */ renderModal(currentModal) {
        const { actionCreatorProviders, dispatcherEventManagement, storeProviders, configProvider, logicModuleProviders, loggers } = this.props;
        const { forms } = configProvider().settings.serviceConfigurations;
        const { clientType } = configProvider().sessionMetaData.appMetadata;
        const onDismiss = async ()=>{
            const modalActionCreator = await actionCreatorProviders.modal();
            modalActionCreator.closeModal();
        };
        switch(currentModal.modalType){
            case ModalType.ConvertPlan:
                return /*#__PURE__*/ React.createElement(LazyConvertPlanContainer, {
                    ...this.props,
                    basicPlanId: currentModal.basicPlanId,
                    basicPlanTitle: currentModal.basicPlanTitle,
                    userHasValidLicense: currentModal.userHasValidLicense
                });
            case ModalType.CreatePlan:
                return currentModal.isTeamsTab ? /*#__PURE__*/ React.createElement(LazyTeamsTabCreatePlanModalContainer, {
                    key: currentModal.modalType,
                    selectedGroupId: currentModal.teamsGroupId,
                    tabId: currentModal.teamsTabId,
                    channelId: currentModal.teamsChannelId,
                    storeProviders: storeProviders,
                    actionCreatorProviders: actionCreatorProviders,
                    dispatcherEventManagement: dispatcherEventManagement,
                    loggers: loggers,
                    configProvider: configProvider
                }) : /*#__PURE__*/ React.createElement(LazyUnoCreatePlanModalContainer, {
                    key: currentModal.modalType,
                    storeProviders: storeProviders,
                    actionCreatorProviders: actionCreatorProviders,
                    dispatcherEventManagement: dispatcherEventManagement,
                    loggers: loggers,
                    configProvider: configProvider
                });
            case ModalType.SelectPlan:
                return /*#__PURE__*/ React.createElement(LazyTeamsSelectPlanModalContainer, {
                    key: currentModal.modalType,
                    storeProviders: storeProviders,
                    actionCreatorProviders: actionCreatorProviders,
                    dispatcherEventManagement: dispatcherEventManagement,
                    onDismiss: onDismiss,
                    loggers: loggers
                });
            case ModalType.CreatePortfolio:
                return /*#__PURE__*/ React.createElement(LazyCreatePortfolioModalContainer, {
                    storeProviders: storeProviders,
                    actionCreatorProviders: actionCreatorProviders,
                    configProvider: configProvider,
                    dispatcherEventManagement: dispatcherEventManagement,
                    loggers: loggers
                });
            case ModalType.DeletePortfolio:
                return /*#__PURE__*/ React.createElement(LazyDeletePortfolioModalContainer, {
                    actionCreatorProviders: actionCreatorProviders,
                    storeProviders: storeProviders,
                    portfolioId: currentModal.portfolioId,
                    dispatcherEventManagement: dispatcherEventManagement,
                    loggers: loggers
                });
            case ModalType.TryPremium:
                return /*#__PURE__*/ React.createElement(LazyTryPremiumContainer, this.props);
            case ModalType.UpsellStatus:
                return /*#__PURE__*/ React.createElement(LazyUpsellStatusContainer, this.props);
            case ModalType.RequestPremiumLicense:
                return /*#__PURE__*/ React.createElement(LazyRequestPremiumLicenseContainer, this.props);
            case ModalType.RenameDialog:
                return /*#__PURE__*/ React.createElement(LazyRenamePlanDialogContainer, this.props);
            case ModalType.RenamePortfolioDialog:
                return /*#__PURE__*/ React.createElement(LazyRenamePortfolioDialogContainer, this.props);
            case ModalType.TaskEditor:
                const loopResponsePage = this.renderLoopPage(currentModal.taskId);
                return /*#__PURE__*/ React.createElement(LazyTaskEditorContainer, {
                    ...this.props,
                    taskId: currentModal.taskId,
                    taskAccessContext: currentModal.taskAccessContext,
                    dialogClassName: "",
                    onOpen: ()=>{},
                    onClose: ()=>currentModal.onDismiss?.()
                }, loopResponsePage);
            case ModalType.FormsIFrame:
                const onFormResponseIdReceived = async (formResponseId)=>{
                    loggers.traceLogger.logTrace(0x1e3e3010 /* tag_4p9aq */ , TraceLevel.Info, `Form response id received: ${formResponseId}`);
                    const taskActionCreator = await actionCreatorProviders.basicTask();
                    taskActionCreator.addFormResponseToTask(currentModal.taskId, formResponseId, currentModal.formId);
                    taskActionCreator.fetchFormResponseForTask(currentModal.taskId, currentModal.formId, true);
                };
                const formsTokenProvider = async ()=>{
                    const formsResourceURI = forms?.authResourceURI ?? this.props.configProvider().settings.serviceConfigurations.forms.authResourceURI;
                    return (await logicModuleProviders.auth().fetchAccessTokenAsync(formsResourceURI)).accessToken;
                };
                const dismissFormsResponseViewOnNewFormResponse = async ()=>{
                    if (currentModal.isOpenFromFormResponseView) {
                        setTimeout(currentModal.onDismiss, 0);
                    }
                    const modalActionCreator = await actionCreatorProviders.modal();
                    modalActionCreator.closeModal();
                };
                return /*#__PURE__*/ React.createElement(LazyFormsIFrameDialogContainer, {
                    ...this.props,
                    telemetryLogger: loggers,
                    onFormResponseIdReceived: onFormResponseIdReceived,
                    urlFormId: currentModal.urlFormId,
                    onDismiss: dismissFormsResponseViewOnNewFormResponse,
                    theme: this.getTheme(),
                    formsTokenProvider: formsTokenProvider,
                    dispatcherEventManagement: dispatcherEventManagement
                });
            case ModalType.CopyTask:
                const onDismissCopyTask = async ()=>{
                    const modalActionCreator = await actionCreatorProviders.modal();
                    modalActionCreator.closeModal();
                    setTimeout(currentModal.onDismiss, 0);
                };
                return /*#__PURE__*/ React.createElement(LazyCopyAndMoveTaskDialogContainer, {
                    ...this.props,
                    taskId: currentModal.taskId,
                    onDismiss: onDismissCopyTask,
                    mode: CopyMoveCustomizerMode.Copy,
                    configProvider: configProvider
                });
            case ModalType.CopyPlan:
                const onDismissCopyPlan = async ()=>{
                    const modalActionCreator = await actionCreatorProviders.modal();
                    modalActionCreator.closeModal();
                    setTimeout(currentModal.onDismiss, 0);
                };
                return /*#__PURE__*/ React.createElement(LazyCopyPlanModalContainer, {
                    ...this.props,
                    planId: currentModal.planId,
                    onDismiss: onDismissCopyPlan
                });
            case ModalType.MoveTask:
                const onDismissMoveTask = async ()=>{
                    const modalActionCreator = await actionCreatorProviders.modal();
                    modalActionCreator.closeModal();
                    setTimeout(currentModal.onDismiss, 0);
                };
                return /*#__PURE__*/ React.createElement(LazyCopyAndMoveTaskDialogContainer, {
                    ...this.props,
                    taskId: currentModal.taskId,
                    onDismiss: onDismissMoveTask,
                    mode: CopyMoveCustomizerMode.Move,
                    configProvider: configProvider
                });
            case ModalType.CopilotUpsell:
                return /*#__PURE__*/ React.createElement(LazyCopilotUpsellContainer, {
                    key: currentModal.modalType,
                    storeProviders: storeProviders,
                    actionCreatorProviders: actionCreatorProviders,
                    dispatcherEventManagement: dispatcherEventManagement,
                    configProvider: configProvider,
                    loggers: loggers
                });
            case ModalType.CopilotSidecar:
                return /*#__PURE__*/ React.createElement(LazyDayTasksCopilotSidecarContainer, {
                    logicModuleProviders: logicModuleProviders
                });
            case ModalType.TaskAttachmentDetailsEditor:
                return /*#__PURE__*/ React.createElement(LazyTaskAttachmentDetailsEditorContainer, {
                    ...this.props,
                    taskId: currentModal.taskId,
                    attachment: currentModal.attachment,
                    elementToFocusOnDismiss: currentModal.elementToFocusOnDismiss
                });
            case ModalType.GetSubscription:
                const target = document.getElementById(ElementIds.CopilotButton);
                return /*#__PURE__*/ React.createElement(LazyGetSubscriptionCallout, {
                    onDismiss: onDismiss,
                    onLearnMoreClick: ()=>safelyOpenExternalUrl(LearnMoreLinks.projectP3SubscriptionPlanLearnMoreUrl, loggers.traceLogger, configProvider().flights.EnableExternalUrlRegexCheck),
                    fromCopilotEntryPoint: true,
                    target: target,
                    directionalHint: DirectionalHint.bottomLeftEdge
                });
            case ModalType.AppInfo:
                return /*#__PURE__*/ React.createElement(LazyAppInfoModal, {
                    onDismiss: onDismiss
                });
            case ModalType.AuthError:
                return /*#__PURE__*/ React.createElement(LazyAuthErrorModalContainer, {
                    ...this.props,
                    onSignInButtonClick: currentModal.onSignInButtonClick,
                    isPopupBlockedError: currentModal.isPopupBlockedError,
                    scopes: currentModal.scopes
                });
            case ModalType.Info:
                return /*#__PURE__*/ React.createElement(LazyInfoModal, {
                    headerText: currentModal.headerText,
                    message: currentModal.message,
                    buttonText: currentModal.buttonText,
                    correlationId: currentModal.correlationId,
                    onDismiss: onDismiss,
                    onButtonClick: currentModal.onButtonClick
                });
            case ModalType.FRE:
                return /*#__PURE__*/ React.createElement(LazyFREDialog, {
                    clientType: clientType,
                    onDismiss: onDismiss,
                    enableExternalUrlRegexCheck: configProvider().flights.EnableExternalUrlRegexCheck
                });
            case ModalType.ShareFileWarning:
                return /*#__PURE__*/ React.createElement(LazyShareFileWarningDialogContainer, {
                    ...this.props,
                    planId: currentModal.planId,
                    taskId: currentModal.taskId,
                    userId: currentModal.userId,
                    onDismiss: onDismiss,
                    onAssignSuccess: currentModal.onAssignSuccess
                });
            case ModalType.DeleteRecurringTask:
                return /*#__PURE__*/ React.createElement(LazyDeleteRecurringTaskDialogContainer, {
                    ...this.props,
                    taskId: currentModal.taskId,
                    onDismiss: currentModal.onDismiss
                });
            case ModalType.AddNonMemberWarning:
                return /*#__PURE__*/ React.createElement(LazyAddNonMemberWarningDialogContainer, {
                    ...this.props,
                    taskId: currentModal.taskId,
                    planId: currentModal.planId,
                    userId: currentModal.userId,
                    assignerHasSharedContainerAccess: currentModal.assignerHasSharedContainerAccess,
                    onAssignSuccess: currentModal.onAssignSuccess,
                    elementToFocusOnDismiss: currentModal.elementToFocusOnDismiss
                });
            case ModalType.SharePlan:
                return /*#__PURE__*/ React.createElement(LazySharePlanDialogContainer, {
                    ...this.props,
                    planId: currentModal.planId,
                    initialSelectedMembersIds: currentModal.userIds
                });
            case ModalType.NotificationSettingsDialog:
                return /*#__PURE__*/ React.createElement(LazyNotificationSettingsDialogContainer, this.props);
            case ModalType.ICalendarDialog:
                return /*#__PURE__*/ React.createElement(LazyICalendarDialogContainer, {
                    ...this.props,
                    planId: currentModal.planId
                });
            case ModalType.DeleteGroup:
                return /*#__PURE__*/ React.createElement(LazyDeleteGroupDialogContainer, {
                    ...this.props,
                    groupId: currentModal.groupId
                });
            case ModalType.DeletePlan:
                return /*#__PURE__*/ React.createElement(LazyDeletePlanDialogContainer, {
                    ...this.props,
                    planId: currentModal.planId
                });
            case ModalType.LeavePlan:
                return /*#__PURE__*/ React.createElement(LazyLeavePlanDialogContainer, {
                    ...this.props,
                    planId: currentModal.planId
                });
            default:
                return null;
        }
    }
    /**
     * Renders a loading spinner
     */ renderLoadingSpinner() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "page-spinner"
        }, /*#__PURE__*/ React.createElement(Spinner, {
            size: SpinnerSize.large,
            className: "spinner",
            label: Strings.UnoShell_SpinnerText,
            styles: appSpinnerStyles
        }));
    }
    /**
     * Render the dev tools
     */ renderDevTools() {
        const { showDevTools } = this.props;
        if (!showDevTools) {
            return null;
        }
        const appContextStore = this.props.storeProviders.appContext();
        const theme = appContextStore.getAppContext().theme;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement(React.Fragment, null)
        }, /*#__PURE__*/ React.createElement(LazyDevPanelContainer, {
            ...this.props,
            currentTheme: theme,
            setTheme: this.setTheme,
            forceUpdateApp: this.forceUpdate.bind(this)
        }));
    }
    /**
     * Render the campaign callout
     */ renderCampaignCallout() {
        const { storeProviders, actionCreatorProviders, dispatcherEventManagement, loggers } = this.props;
        // If the Iris campaigns are disabled, don't render the campaign callout
        if (this.props.configProvider().settings.irisCampaignSettings.disableIrisCampaignCallouts) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement(React.Fragment, null)
        }, /*#__PURE__*/ React.createElement(LazyCampaignCalloutContainer, {
            storeProviders: storeProviders,
            actionCreatorProviders: actionCreatorProviders,
            dispatcherEventManagement: dispatcherEventManagement,
            loggers: loggers,
            appContentId: this.getUnoMainContentId(),
            configProvider: this.props.configProvider
        }));
    }
    /**
     * Render the suite nav
     */ renderSuiteNav() {
        const { isDevMode, configProvider } = this.props;
        const clientType = configProvider().sessionMetaData.appMetadata.clientType;
        if (isDevMode || clientType !== ClientType.Web) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement(SuiteNavLoadingPlaceHolder, null)
        }, /*#__PURE__*/ React.createElement(LazySuiteNavContainer, this.props));
    }
    /**
     * Render the app content
     * @param unoShellClassNames The classname for the uno shell
     * @param clientFlavor The client flavor
     * @param subRouteType The sub route type
     */ renderAppContent(unoShellClassNames, clientFlavor, subRouteType) {
        return /*#__PURE__*/ React.createElement("div", {
            className: unoShellClassNames.appContent
        }, clientFlavor !== ClientFlavor.Tab && subRouteType !== SubRouteType.ConfigTeamsTab && subRouteType !== SubRouteType.RemoveTeamsTab && this.renderLeftNav(), /*#__PURE__*/ React.createElement("div", {
            id: multiPageDialogHostId,
            className: unoShellClassNames.mainContentContainer
        }, this.renderNotificationBar(unoShellClassNames.notificationBar), this.renderPrimaryView()));
    }
    /**
     * Renders the notificationBar
     * @param notificationBarClassName The classname for the notification bar
     */ renderNotificationBar(notificationBarClassName) {
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement(React.Fragment, null)
        }, /*#__PURE__*/ React.createElement(LazyNotificationBarContainer, {
            ...this.props,
            className: notificationBarClassName
        }));
    }
    /**
     * Render the toast container
     */ renderToastContainer() {
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement(React.Fragment, null)
        }, /*#__PURE__*/ React.createElement(LazyToastContainer, {
            ...this.props,
            layerProps: {
                hostId: this.getUnoMainContentId()
            }
        }));
    }
    renderCreateTeamsTabPage() {
        const { configProvider, actionCreatorProviders, dispatcherEventManagement, storeProviders, loggers, hostAdaptor } = this.props;
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: this.renderLoadingSpinner()
        }, /*#__PURE__*/ React.createElement(LazyCreateTeamsTabPage, {
            configProvider: configProvider,
            actionCreatorProviders: actionCreatorProviders,
            storeProviders: storeProviders,
            dispatcherEventManagement: dispatcherEventManagement,
            dispatchPageReady: this.dispatchPageReady,
            loggers: loggers,
            teamsHostAdaptor: hostAdaptor,
            canSetDocumentTitle: hostAdaptor.canSetDocumentTitle()
        }));
    }
    /**
     * Get the main content id for this Uno app instance
     */ getUnoMainContentId() {
        const appContextStore = this.props.storeProviders.appContext();
        return getUnoMainContentId(appContextStore.getAppInstanceId());
    }
    /**
     * Get the classnames associated with the computed styles for the Uno shell
     */ getUnoShellClassNames(currentTheme) {
        return getUnoShellClassNames(getUnoShellStyles(currentTheme));
    }
    /**
     * Get the theme for the rendering views.
     * If a theme is already set in the state, it returns that theme.
     * Otherwise, it creates and returns a new theme.
     */ getTheme() {
        return this.state.v8Theme ?? createTheme();
    }
    /**
     * Setup the office feedback sdk
     * @param isDevMode Parameter indicating we are rendering in the dev mode
     */ async setupOfficeFeedback(isDevMode) {
        const { actionCreatorProviders } = this.props;
        const ocvActionCreator = await actionCreatorProviders.ocv();
        ocvActionCreator.initOCV(isDevMode);
    }
    /**
     * Setup the idle time tracker.
     * Update UserActivityTimestamp on user's action. But only update at most once per minute.
     */ startUserActivityTracking() {
        const activityHandler = throttle(async ()=>{
            const timestamp = moment();
            const activityActionCreator = await this.props.actionCreatorProviders.activity();
            activityActionCreator.updateUserActivityTimestamp(timestamp);
        }, UserActivitySamplingResolutionMs);
        const events = [
            "click",
            "dblclick",
            "mousemove",
            "mouseup",
            "mousedown",
            "mouseenter",
            "keyup",
            "keydown",
            "keypress",
            "submit",
            "change",
            "scroll",
            "resize"
        ];
        for (const eventName of events){
            document.addEventListener(eventName, activityHandler, {
                capture: true
            });
        }
    }
    /**
     * Render the news bar
     * @param newsId The news id
     */ renderNewsBar(newsId) {
        const shouldShowUnoWebRedirectBanner = this.state.newsBarStore?.getShowNewsBar(NewsBarNewsIds.OcdiRedirectExperience);
        const isRedirectBannerEnabled = this.props.configProvider().flights.EnableOcdiRedirectBanner;
        if (!shouldShowUnoWebRedirectBanner || !isRedirectBannerEnabled) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement(React.Fragment, null)
        }, /*#__PURE__*/ React.createElement(LazyNewsBarContainer, {
            newsId: newsId,
            dispatcherEventManagement: this.props.dispatcherEventManagement,
            actionCreatorProviders: this.props.actionCreatorProviders,
            loggers: this.props.loggers
        }));
    }
    /** Renders the Floating Action Button control on basic plans */ renderFAB() {
        const { configProvider, storeProviders } = this.props;
        const routeStore = storeProviders.route();
        const subRouteType = routeStore.getCurrentSubRouteType();
        if (!configProvider().flights.EnableBasicPlanFAB || subRouteType !== SubRouteType.BasicPlan) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: null
        }, /*#__PURE__*/ React.createElement(LazyFloatingActionButtonContainer, null));
    }
    constructor(props, context){
        super(props, context), this.currentTheme = UnoTheme.Light, /** The short-circuit flags for whether or not instantiation has started. Used because store based status setting is async */ this.instantiationStartedFlags = {
            [UnoChildView.BasicPlan]: false,
            [UnoChildView.PremiumPlan]: false,
            [UnoChildView.Portfolio]: false
        }, /** The number of times we've retried instantiation */ this.instantiationRetryCounts = {
            [UnoChildView.BasicPlan]: 0,
            [UnoChildView.PremiumPlan]: 0,
            [UnoChildView.Portfolio]: 0
        }, // TODO: WI#8826842: Track view lifecycle complete states separate from UnoShell state/store that causes re-renders
        /**
     * Tracking all view complete states, including intermediate states like
     * Instantiating, ScriptsLoaded and ReInstantiate that don't affect UX rendering/react-re-rendering,
     * but are needed for the general view lifecycle control flow
     **/ this.viewStatuses = {
            legacyTTStatus: UnoViewStatus.NotLoaded
        }, /**
     * Set the theme for the Uno Shell
     */ this.setTheme = async (theme)=>{
            const appContextAc = await this.props.actionCreatorProviders.appContext();
            appContextAc.updateAppTheme(theme);
        }, /**
     * Fetch upsell data
     */ this.fetchUpsellDataAsync = async ()=>{
            const { actionCreatorProviders, isDevMode } = this.props;
            // Fetch subscription status
            const upsellAc = await actionCreatorProviders.upsell();
            upsellAc.fetchProjectSubscriptionStatus();
            if (!isDevMode) {
                // Initialize Centro license request hvc
                upsellAc.initializeRequestLicenseHVC();
            }
        }, /**
     * Dispatch pageReady action
     */ this.dispatchPageReady = (dataFetchStart, dataFetchEnd, exportName, metaTag, extraData)=>{
            const { actionCreatorProviders } = this.props;
            const perfCollectionActionCreator = actionCreatorProviders.performanceCollection();
            perfCollectionActionCreator.pageReady(dataFetchStart, dataFetchEnd, exportName, metaTag, extraData);
        };
        this.state = {
            legacyTTStatus: UnoViewStatus.NotLoaded,
            v8Theme: null,
            modalStore: null,
            newsBarStore: null
        };
        // Initialize icons
        initializeAndRegisterIcons();
        // Initialize resource localization
        loadTranslations(this.props.storeProviders.appContext().getAppContext().locale);
    }
}
/**
 * Set the dnd backend for the Uno Shell and child views
 * @param dndBackend The current dnd backend to update the views with
 */ const setDndBackend = async (dndBackend)=>{
    (await premiumPlanInstantiateLoader()).setDndBackend(dndBackend);
    (await basicPlanInstantiateLoader()).setDndBackend(dndBackend);
};
export const UnoShell = (props)=>{
    const WrappedComponent = withDndContext(UnoShellInternal, setDndBackend);
    return /*#__PURE__*/ React.createElement(StoreSubscriptionManagerContext.Provider, {
        value: props.dispatcherEventManagement
    }, /*#__PURE__*/ React.createElement(ConfigProviderContext.Provider, {
        value: props.configProvider
    }, /*#__PURE__*/ React.createElement(LoggerContextProvider, {
        value: props.loggers
    }, /*#__PURE__*/ React.createElement(StoreLoaderContext.Provider, {
        value: props.storeProviders
    }, /*#__PURE__*/ React.createElement(ActionCreatorLoaderContext.Provider, {
        value: props.actionCreatorProviders
    }, /*#__PURE__*/ React.createElement(WrappedComponent, props))))));
};
